import { useBreakpointValue } from '@chakra-ui/media-query';

import { clickLPConversionButton } from '@/utils/analytics/log-event';

import { LandingPageProps } from '..';

import ConversionButton from './ConversionButton';
import mainImagePC from './images/first_view/pc.png';
import mainImageSP from './images/first_view/sp.png';

type Props = {
  lpProps: LandingPageProps;
  scrollToForm: () => void;
};

const Component: React.FC<Props> = ({ lpProps, scrollToForm }) => {
  const bgImageSrc = useBreakpointValue({ base: mainImageSP, md: mainImagePC });
  return (
    <div
      className="relative mb-16 flex w-[calc(100%+16px)] bg-cover bg-no-repeat bg-origin-border py-24 text-[#202956] md:mb-4 md:w-full md:pt-12"
      style={{
        backgroundImage: bgImageSrc ? `url(${bgImageSrc.src})` : undefined,
      }}
    >
      <div className="w-full px-10 md:ml-20 md:w-fit md:p-0">
        <div className="text-3xl font-black md:text-[50px] md:leading-tight">
          卓球で
          <br />
          上を目指すなら
        </div>
        <div className="my-5 w-fit bg-white/70 p-1 text-sm font-black md:bg-white md:p-2 md:text-[23px]">
          {lpProps.totalVideos}本以上のレッスン動画を見放題
        </div>
        <div className="mt-10 h-[60px] w-full md:w-4/5">
          <ConversionButton
            scrollToForm={() => {
              scrollToForm();
              clickLPConversionButton('first_view');
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Component;
